import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./style.scss";

const OEQDisplay = ({ component, oeqState }) => {
  const { sourceOEQId, heading, noResponseText } = component;

  const oeqResponse = oeqState && oeqState[sourceOEQId];
  const responseText = oeqResponse && oeqResponse.text ? oeqResponse.text : noResponseText;

  // Show the component if there's any text response or if it's completed
  if (!oeqResponse || (!oeqResponse.text && !oeqResponse.complete)) {
    return null;
  }

  return (
    <div className="oeq-display">
      {heading && <h4 className="oeq-display__heading">{heading}</h4>}
      <div className="oeq-display__content">
        <p className="oeq-display__response">{responseText}</p>
      </div>
    </div>
  );
};

OEQDisplay.propTypes = {
  component: PropTypes.shape({
    sourceOEQId: PropTypes.number.isRequired,
    heading: PropTypes.string,
    noResponseText: PropTypes.string,
  }).isRequired,
  oeqState: PropTypes.object,
};

const mapStateToProps = (state) => ({
  oeqState: state.oeq,
});

export default connect(mapStateToProps)(OEQDisplay);
